module.exports = __webpack_public_path__ + "static/media/pecuaria-newmobile.595728db.jpg";